import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import ThresholdPopup from "../ThresholdPopup/ThresholdPopup.vue";
import CriticalDPModal from '../CriticalDPPopup/CriticalDPModal.vue';

export default {
  name: "ractTool",
  components: {
    ThresholdPopup,
    CriticalDPModal
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idtoken: "",
      totalCount: 0,
      pageindex: 1,
      pagesize: 200,
      ConvertTonumeric: true,
      SortProperty: "CategoryId",
      SortOrder: "0",
      ractlist: [],
      getColumns: [],
      currentTemplatePage: 1,
      totalTemplatePages: 1,
      showMoreDescription: {},
      showMoreCategory: {},
      editedRowId: null,
      dropdownOpen: false,
      showFilter: false,
      showTableLoader: false,
      selectedcolumnobj: {},
      selectedColumns: [],
      editableRow: {},
      overallRiskLevel: "Low",
      phase: "",
      typeOfRisk: "",
      typeOfRiskList: [],
      phases: [],
      categoryList: [],
      category: "",
      scoreMap: {
        High: 3,
        Medium: 2,
        Low: 1,
        "Difficult to detect": 3,
        "Medium to detect": 2,
        "Easy to detect": 1,
      },
      createRiskScore: {
        categoryId: "",
        riskName: "",
        studyId: "",
        siteId: "",
        dataScopeId: "",
        dataScope: "",
        probability: "",
        impact: "",
        detectability: "",
        value: "",
        unit: ""
      },
      defaultdate: "",
      studyId: "",
      selectedSiteId: "",
      sites: [],
      showThresholdPopup: false,
      selectedRiskId: "",
      selectedVersion: "",
      showCriticalPopUp: false,
      criticalDataPoints: [],
      averageRisk: 0,
    };
  },
  async mounted() {
    this.idtoken = store.getters.getIdToken;
    this.defaultdate = localStorage.getItem("dateformat");
    this.studyId = store.getters.getStudyIs;

    window.addEventListener("studyIdChanged", (event) => {
      console.log("StudyIDChanged into" + event.detail.storage);
      this.rollsprivilages = store.getters.getRolesprivilegeData;
      this.studyId = event.detail.storage;
      this.getsites();
      this.getRactData();
      this.ListPhase();
      this.ListCategory();
      this.ListTypeOfRisk();
      this.initializeColumns();
    });

    await this.getsites();
    await this.getRactData();
    await this.ListPhase();
    await this.ListCategory();
    await this.ListTypeOfRisk();
    await this.initializeColumns();
  },
  computed: {
    totalRiskScoreSum() {
      return this.ractlist.reduce((sum, item) => {
        return sum + (item.totalCategoryRiskScore || 0);
      }, 0);
    },
    computedRiskLevel() {
      const total = this.totalRiskScoreSum;
      if (total > 20) return "High";
      if (total >= 10) return "Medium";
      return "Low";
    },
    riskStatus() {
      // min and max is 1 to 27 if the risk range is 1 to 3 (for PDI)
      const avg = this.averageRisk;
      const min = 1;
      const max = 27;
      const band = (max - min) / 3;

      if (avg < min + band) return "Low";
      if (avg < min + band * 2) return "Medium";
      return "High";
    }
  },
  methods: {
    // Converts a CTQ risk entity (new /forms/ctq/getallrisk shape) into the
    // flat shape the template/table already knows how to render.
    mapCtqToRactItem(item) {
      const impactPoint = item.impact || 0;
      const probabilityPoint = item.probability || 0;
      const detectabilityPoint = item.detectability || 0;

      return {
        id: item.id,
        studyId: item.studyId,
        categoryId: item.riskId,
        ctqId: item.ctqId,
        ctqFactor: item.ctqFactor,
        category: item.riskCategory,
        subCategory: item.subCategory,
        dataScope: "Study", // no per-item dataScope in new schema; defaulting
        riskIndicator: item.riskStatement,
        discussionDetails: item.failureMode,
        rootCause: item.rootCause,
        consequence: item.consequence,
        objectives: item.objectives,
        levelOfScrutiny: item.levelOfScrutiny,
        thresholdBasis: item.scoreRationale,
        phase: item.phase,
        typeOfRisk: item.typeOfRisk,
        riskLevelLabel: item.riskLevel,
        riskOwner: item.riskOwner,
        detectionMethod: item.detectionMethod,
        status: item.status,
        scoringStatus: item.scoringStatus,
        residualRpn: item.residualRpn,
        residualRiskLevel: item.residualRiskLevel,

        probabilityPoint,
        impactPoint,
        detectabilityPoint,
        totalCategoryRiskScore:
          item.rpn != null ? item.rpn : impactPoint * probabilityPoint * detectabilityPoint,

        // Reverse-derive High/Medium/Low labels for the edit dropdowns
        impact: ["Low", "Medium", "High"][impactPoint - 1] || "Low",
        probability: ["Low", "Medium", "High"][probabilityPoint - 1] || "Low",
        detectability:
          ["Easy to detect", "Medium to detect", "Difficult to detect"][detectabilityPoint - 1] ||
          "Easy to detect",

        executionType: "Manual", // no equivalent field; defaulting so existing UI branches still work
        unit: null,
        value: null,
        CreatedAt: null, // not present in the new response

        // fields with no equivalent in the new schema — left null so template renders blank
        weighting: null,
        scorecard: null,
        mitigationActions: null,
        coreOrExtendedKRI: null,
        frequency: null,
        siteId: item.siteId || null, // not present yet; kept for future-proofing
      };
    },

    initializeColumns() {
      if (this.ractlist.length > 0) {
        const allowedKeys = [
          "categoryId",
          "category",
          "subCategory",
          "dataScope",
          "objectives",
          "riskIndicator",
          "discussionDetails",
          "unit",
          "core",
          "levelOfScrutiny",
          "frequency",
          "thresholdBasis",
          "impactPoint",
          "probabilityPoint",
          "detectabilityPoint",
          "totalCategoryRiskScore",
          "scorecard",
          "weighting",
          "mitigationAction",
          "riskRating",
          "phase",
          "executionType",
          "executionDate",
          "value",
          "typeOfRisk",
        ];
        this.getColumns = Object.keys(this.ractlist[0]).filter((column) =>
          allowedKeys.includes(column)
        );
        const fieldLabels = {
          categoryId: "Category ID",
          category: "Category",
          subCategory: "Sub Category",
          dataScope: "Data Scope",
          objectives: "Objectives",
          riskIndicator: "Risk Indicator",
          discussionDetails: "Discussion Details",
          unit: "Unit",
          core: "Core",
          levelOfScrutiny: "Level of Scrutiny",
          frequency: "Frequency",
          thresholdBasis: "Threshold Basis",
          impactPoint: "Impact",
          probabilityPoint: "Probability",
          detectabilityPoint: "Detectability",
          totalCategoryRiskScore: "Risk Score",
          scorecard: "Score Card",
          weighting: "Weighting",
          mitigationAction: "Mitigation Action",
          riskRating: "Risk Rating",
          phase: "Phase",
          executionType: "Execution Type",
          executionDate: "Execution Date",
          value: "Derived Value",
          typeOfRisk: "Type of Risk",
        };

        const readableData = allowedKeys.map((key) => fieldLabels[key] || key);
        const initiallyTrueKeys = [
          "Category ID",
          "Category",
          "Sub Category",
          "Data Scope",
          "Risk Indicator",
          "Execution Type",
          "Derived Value",
          "Unit",
          "Impact",
          "Probability",
          "Detectability",
          "Risk Score",
        ];

        this.getColumns = readableData;
        this.selectedColumns = initiallyTrueKeys;
        this.selectedcolumnobj = this.getColumns.reduce((obj, key) => {
          obj[key] = initiallyTrueKeys.includes(key);
          return obj;
        }, {});
        console.log("object", this.selectedColumns);
      }
    },
    async startEdit(item) {
      this.editedRowId = item.id;
      this.editableRow = { ...item };
    },
    async updateScore() {
      const impact = this.scoreMap[this.editableRow.impact] || 0;
      const probability = this.scoreMap[this.editableRow.probability] || 0;
      const detectability = this.scoreMap[this.editableRow.detectability] || 0;

      this.editableRow.totalCategoryRiskScore = impact * probability * detectability;
    },
    cancelEdit() {
      this.editedRowId = null;
      this.editableRow = {};
    },
    deleteRact(id) {
      // NOTE: still pointing at the old rbqm delete endpoint.
      // Confirm the CTQ-side delete endpoint (likely /forms/ctq/delete) before relying on this.
      if (confirm("Are you sure you want to delete this risk assessment?")) {
        axios
          .delete(`${this.baseurl}/forms/rbqm/delete?id=${id}`, {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            },
          })
          .then(() => {
            this.ractlist = this.ractlist.filter((item) => item.id !== id);
            alert("Risk assessment deleted successfully!");
          })
          .catch((error) => {
            console.error("Failed to delete:", error);
          });
      }
    },
    async saveRow(id) {
      // NOTE: still pointing at the old rbqm update endpoint and payload shape.
      // Once a CTQ-side update endpoint exists, this payload should be rebuilt using
      // the camelCase CTQ field names (riskStatement, riskCategory, failureMode, etc.)
      // instead of the legacy rbqm field names below.
      const {
        category,
        subCategory,
        dataScope,
        riskIndicator,
        discussionDetails,
        coreOrExtendedKRI,
        generalOrSpecific,
        levelOfScrutiny,
        executionType,
        value,
        frequency,
        thresholdBasis,
        scorecard,
        weighting,
        mitigationActions,
        categoryId,
        phase,
        executionDate,
        typeOfRisk,
        objectives,
        studyId,
        templateId,
      } = this.editableRow;

      const impactPoint = this.scoreMap[this.editableRow.impact] || 0;
      const probabilityPoint = this.scoreMap[this.editableRow.probability] || 0;
      const detectabilityPoint = this.scoreMap[this.editableRow.detectability] || 0;

      const payload = {
        id,
        category,
        subCategory,
        dataScope,
        riskIndicator,
        discussionDetails,
        coreOrExtendedKRI,
        generalOrSpecific,
        levelOfScrutiny,
        executionType,
        value,
        frequency,
        thresholdBasis,
        scorecard,
        weighting,
        mitigationActions,
        phase,
        executionDate,
        typeOfRisk,
        objectives,
        studyId,
        templateId,
        impactPoint,
        probabilityPoint,
        detectabilityPoint,
      };

      try {
        await axios.put(`${this.baseurl}/forms/rbqm/update`, payload, {
          headers: {
            Authorization: "Bearer " + this.idtoken,
            "Content-Type": "application/json",
          },
        });

        const index = this.ractlist.findIndex((r) => r.id === id);
        if (index !== -1) {
          this.ractlist[index] = {
            ...this.editableRow,
            impactPoint,
            probabilityPoint,
            detectabilityPoint,
            totalCategoryRiskScore: impactPoint * probabilityPoint * detectabilityPoint,
          };
        }

        this.editedRowId = null;
        this.editableRow = {};
        alert("Row updated successfully!");
      } catch (error) {
        console.error("Failed to update:", error);
      }
    },

    async getRactData() {
  const idtoken = store.getters.getIdToken;
  this.showTableLoader = true;
  try {
    const res = await axios.get(
      `${this.baseurl}/forms/ctq/getallrisk?StudyId=${this.studyId}`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    const rawList = (res.data && res.data.entities) ? res.data.entities : [];
    this.ractlist = rawList.map(this.mapCtqToRactItem);
    this.totalCount = (res.data && res.data.totalCount !== undefined && res.data.totalCount !== null)
      ? res.data.totalCount
      : this.ractlist.length;
    this.totalTemplatePages = Math.ceil(this.totalCount / this.pagesize);
    this.averageRisk = 0; // no studyScore field in new response
  } catch (err) {
    console.log("error..", err);
  } finally {
    this.showTableLoader = false;
  }
    },

    async SearchRACT() {
      const idtoken = store.getters.getIdToken;
      this.showTableLoader = true;
      try {
        const res = await axios.get(
          `${this.baseurl}/forms/ctq/getallrisk?StudyId=${this.studyId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const rawList = (res.data && res.data.entities) ? res.data.entities : [];
        let mapped = rawList.map(this.mapCtqToRactItem);

        if (this.phase) {
          mapped = mapped.filter((i) => i.phase === this.phase);
        }
        if (this.category) {
          mapped = mapped.filter((i) => i.category === this.category);
        }
        if (this.typeOfRisk) {
          mapped = mapped.filter((i) => i.typeOfRisk === this.typeOfRisk);
        }

        this.ractlist = mapped;
        this.totalCount = mapped.length;
        this.totalTemplatePages = Math.ceil(this.totalCount / this.pagesize);
      } catch (err) {
        console.error("Search error:", err);
      } finally {
        this.showTableLoader = false;
      }
    },

    async CreateRiskScore(item) {
      const idtoken = store.getters.getIdToken;

      const impact = this.scoreMap[this.editableRow.impact] || 0;
      const probability = this.scoreMap[this.editableRow.probability] || 0;
      const detectability = this.scoreMap[this.editableRow.detectability] || 0;
      const rpn = impact * probability * detectability;

      const riskLevel = this.deriveRiskLevel(rpn);

      const payload = {
        studyId: item.studyId,
        riskId: item.categoryId,
        ctqId: item.ctqId,
        ctqFactor: item.ctqFactor,
        riskStatement: item.riskIndicator,
        failureMode: item.discussionDetails,
        rootCause: item.rootCause,
        consequence: item.consequence,
        riskCategory: item.category,
        subCategory: item.subCategory,
        typeOfRisk: item.typeOfRisk,
        phase: item.phase,
        levelOfScrutiny: item.levelOfScrutiny,
        probability,
        impact,
        detectability,
        rpn,
        riskLevel,
        residualRpn: item.residualRpn || 0,
        residualRiskLevel: item.residualRiskLevel || "",
        scoreRationale: item.thresholdBasis,
        scoringStatus: "Completed",
        riskOwner: item.riskOwner,
        detectionMethod: item.detectionMethod,
        objectives: item.objectives,
        status: item.status || "Open",
        executionType: "Manual",
        isActive: true,
      };

      try {
        await axios.put(
          `${this.baseurl}/forms/ctq/updateriskitem?id=${item.id}`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Risk score updated successfully");
        this.editedRowId = null;
        this.editableRow = {};
        await this.getRactData();
      } catch (error) {
        console.error("Error updating risk score:", error);
        alert("Failed to update risk score. Please try again.");
      }
    }, 
    deriveRiskLevel(rpn) {
      const min = 1;
      const max = 27;
      const band = (max - min) / 3;

      if (rpn < min + band) return "Low";
      if (rpn < min + band * 2) return "Medium";
      return "High";
    },
    async ListPhase() {
      const idtoken = store.getters.getIdToken;
      try {
        const response = await axios.get(
          `${this.baseurl}/forms/rbqm/distintfieldvalues?fieldname=phase`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.phases = response.data;
        console.log("Phases fetched successfully:", this.phases);
      } catch (error) {
        console.error("Error fetching phases:", error);
        return [];
      }
    },
    async ListTypeOfRisk() {
      const idtoken = store.getters.getIdToken;
      try {
        const response = await axios.get(
          `${this.baseurl}/forms/rbqm/distintfieldvalues?fieldname=typeOfRisk`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.typeOfRiskList = response.data;
        console.log("Type of Risk fetched successfully:", this.typeOfRiskList);
      } catch (error) {
        console.error("Error fetching Type of Risk:", error);
        this.typeOfRiskList = [];
      }
    },
    async ListCategory() {
      const idtoken = store.getters.getIdToken;
      try {
        const response = await axios.get(
          `${this.baseurl}/forms/rbqm/distintfieldvalues?fieldname=category`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.categoryList = response.data;
        console.log("Category fetched successfully:", this.categoryList);
      } catch (error) {
        console.error("Error fetching Category:", error);
        this.categoryList = [];
      }
    },
    async getsites() {
      const idtoken = store.getters.getIdToken;
      const currentstudy = store.getters.getStudyIs;
      await axios
        .get(`${this.baseurl}/management/site/getallsitesbyuser?studyId=${currentstudy}&getAll=false`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.sites = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    LoadData: function (page) {
      this.currentTemplatePage = page;
      this.getRactData();
    },
    filter(data) {
      if (data) {
        return moment(data).format(this.defaultdate)
      }
    },
    showCriticalDP(risk) {
      this.selectedRiskId = risk.categoryId;
      this.selectedVersion = risk.version;
      this.showThresholdPopup = true;
    },
    async openCriticalDP(risk) {
      if (risk.executionType == "Manual") {
        await this.getCriticaldataPoints("Default", 1);
      }
      else {
        await this.getCriticaldataPoints(risk.categoryId, risk.version);
      }
      await this.openCriticalPopup();
    },
    async getCriticaldataPoints(categoryId, version) {
      const idtoken = store.getters.getIdToken;
      const currentstudy = store.getters.getStudyIs;
      try {
        var res = await axios.get(`${this.baseurl}/forms/rbqm/getcriticaldatapoints?studyId=${currentstudy}&riskId=${categoryId}&version=${version}&isActive=true`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Critical Data Points:", res.data);
        this.criticalDataPoints = res.data.entities;
      } catch (error) {
        console.error("Error fetching critical data points:", error);
      }
    },
    async openCriticalPopup() {
      this.showCriticalPopUp = true;
    },
    async closeCriticalDataPopup() {
      this.criticalDataPoints = [];
      this.showCriticalPopUp = false;
    },
  },
};